import unitReducer from '../unit/unit.reducer';

function save(session, sectionObj) {
    const {Section} = session;
    if (Section.idExists(sectionObj.id)) {
        Section.withId(sectionObj.id).units.all().delete();
    }
    let units = null;
    if (sectionObj.units) {
        units = sectionObj.units.map((unitObj, index) => {
            return unitReducer.save(session, unitObj);
        });
    }
    return Section.create({
        ...sectionObj,
        units
    });
}

function remove(session, id) {
    const {Section} = session;
    if (!Section.idExists(id)) {
        throw new Error(`can not find section with id '${id}'`);
    }
    Section.withId(id).units.toRefArray().forEach((u) => {
        unitReducer.remove(session, u.id);
    });
    return Section.withId(id).delete();
}


export default {
    save,
    remove,
};